import {DocumentModule} from '../../../document/document.module';
import {NgModule} from '@angular/core';

@NgModule({
    imports: [
        DocumentModule
    ]
})
export class PartnerDocumentModule {
}
